import {
  normalizeCityId,
  SOUTH_SHORE_CITY_ID,
  ANNAPOLIS_VALLEY_CITY_ID
} from '@/utils/cityIds'

/** User-facing pickup program name (canonical city id → display title). */
const PICKUP_CITY_DISPLAY_NAMES = {
  halifax: 'Halifax Pickup Hockey',
  [SOUTH_SHORE_CITY_ID]: 'South Shore Pickup Hockey',
  [ANNAPOLIS_VALLEY_CITY_ID]: 'Annapolis Valley Pickup Hockey'
}

/** Hub card subtitle (towns / region). Prefer Firestore regionLabel when set. */
const PICKUP_CITY_REGION_LABELS = {
  halifax: 'Halifax, NS',
  [SOUTH_SHORE_CITY_ID]: 'Bridgewater & Liverpool, NS',
  [ANNAPOLIS_VALLEY_CITY_ID]: 'Wolfville, NS'
}

/**
 * Display name for pickup city surfaces (home, admin header, notifications).
 * Bridgewater id always shows "South Shore Pickup Hockey", not legacy Firestore labels.
 */
export function getPickupCityDisplayName (city) {
  if (!city) return 'Nova Adult Hockey'
  const id = normalizeCityId(city.id || city.slug)
  if (id && PICKUP_CITY_DISPLAY_NAMES[id]) {
    return PICKUP_CITY_DISPLAY_NAMES[id]
  }
  const raw = city.displayName || city.name || ''
  if (/bridgewater/i.test(raw) && /pickup|adult|hockey/i.test(raw)) {
    return PICKUP_CITY_DISPLAY_NAMES[SOUTH_SHORE_CITY_ID]
  }
  return raw || 'Nova Adult Hockey'
}

/**
 * Landing-page meta under the program name (e.g. "Bridgewater & Liverpool, NS").
 */
export function getPickupCityRegionLabel (city) {
  if (!city) return ''
  if (city.regionLabel) return String(city.regionLabel).trim()
  const id = normalizeCityId(city.id || city.slug)
  if (id && PICKUP_CITY_REGION_LABELS[id]) return PICKUP_CITY_REGION_LABELS[id]
  const name = city.name || city.displayName || ''
  return name ? `${name}, NS` : ''
}
